import { stringToMoment } from '../../utils/dateUtils';

export const NAME = 'giveaway';

export const REQUEST_FIND_ACTIVE_CONTEST = 'REQUEST_FIND_ACTIVE_CONTEST';
export const RECEIVE_FIND_ACTIVE_CONTEST = 'RECEIVE_FIND_ACTIVE_CONTEST';
export const FAILURE_FIND_ACTIVE_CONTEST = 'FAILURE_FIND_ACTIVE_CONTEST';

export const REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION = 'REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION';
export const SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION = 'SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION';
export const FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION = 'FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION';

export const RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION = 'RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION';

export const REQUEST_IS_USER_REGISTERED_TO_CONTEST = 'REQUEST_IS_USER_REGISTERED_TO_CONTEST';
export const RECEIVE_IS_USER_REGISTERED_TO_CONTEST = 'RECEIVE_IS_USER_REGISTERED_TO_CONTEST';
export const FAILURE_IS_USER_REGISTERED_TO_CONTEST = 'FAILURE_IS_USER_REGISTERED_TO_CONTEST';

export const CONTEST_COOKIE_PREFIX = 'contest-';
export const CONTEST_MODAL_MAXIMUM_DISPLAY = 2;

export const CONTEST_END_COOKIE_PREFIX = 'contest-end';
export const CONTEST_END_MODAL_MAXIMUM_DISPLAY = 1;
export const CONTEST_END_MODAL_START_DATE = stringToMoment('2025-12-18 00:00:00');
export const CONTEST_END_MODAL_END_DATE = stringToMoment('2025-12-31 23:59:59');



// WEBPACK FOOTER //
// ./src/services/giveaway/constants.js